import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../breadcrumb.service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { ServiciosStatsProvider } from '../../providers/web-service-service/servicios-stats';
import { CeldaContenido } from '../../domain/CeldaContenido';
import { BalizaFormulario_lite } from '../../domain/BalizaFormulario_lite';
import { FotoBlob } from '../../domain/FotoBlob';
import { TranslateService } from 'ng2-translate';
import { Message } from 'primeng/primeng';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import {
	Predicate
} from 'breeze-client';

import {
	Constantes
} from '../../domain/constantes';
import { AppComponent } from '../../app.component';
import { environment } from '../../../environments/environment';
import { forEach } from '@angular/router/src/utils/collection';

const VISITAUSUARIOS = 1;
const BUSCACONTENIDO = 2;

const BEACONBATERIAMIN:Number = 20;
const BEACONMINDAYS = 30;

const CACHE_DESF_SEC = 120;

@Component({
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

	public EXPIRADO = 0;
	public PROXIMO = 1;
	public EXPIRA = 2;
	public ACTIVO = 3;
	listaContenidosFavoritos:  {
		lista: undefined[],
		msg: '',
		res: 0
	};
	listaContenidos: any[] = [];
	listaRutas: any[] = [];
	listaNoticias: any[] = [];
	listaUbicaciones: any[] = [];

	listaContenidosCaducar: any[] = [];

	listaCeldaContenidos: CeldaContenido[] = [];
	listaFotosContenidos: FotoBlob[] = [];
	listaFotosContenidosURL: any[] = [];

	listaFotosRutasURL: any[] = [];
	listaImagesGaleriaRutasURL: any[] = [];
	listaFotosNoticias: FotoBlob[] = [];
	listaImagesGaleriaNoticias: any[] = [];

	listaResumen: any = {
	};

	images: any[];
	listaVisitasDiarias: any[] = [];
	chartDataMensual: any = [];
	chartDataMensualLast: any = [];
	chartDataAnual: any;
	chartMensaje: string;
	hotMapMes: string;
	contenidosIndicadores: any;
	contenidosIndicadoresFavoritos: any;
	cars: any;
	secciones: any = {};

	visitasSeccion: any[];
	visitasNodo: any[];

	todosContenidosFiltrados: any[] = [];

	numeroTramosCortados: number;

	msgs: Message[] = [];
	spinner: HTMLElement;
	blockUI: HTMLElement;

	mapaPantallaCompletaVisible:boolean = false;

	puntos = [];
	radius=250;
	opacity=0.5;
	scale = 0.1;
	useOpacity=true;

	numAla = 0; // Ala seleccionada
    numTipo = 0; // Tipo preview ala seleccionado

	constructor(
		private appComponent: AppComponent,
		private breadcrumbService: BreadcrumbService,
		private entityManager: EntityManagerProvider,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		public translate: TranslateService,
		public statsService: ServiciosStatsProvider,
		public router: Router,
		private cd: ChangeDetectorRef
	) {

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Dashboard.dashboard') }
		]);

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';

		//this.puntos = this.generarPuntosEjemplo();
	}

	ngOnInit() {
		window.scroll(0, 0);
		const that = this;
		this.listaContenidos = [];
		this.listaFotosContenidos = [];
		this.listaContenidosCaducar = [];
		this.listaCeldaContenidos = [];
		this.listaRutas = [];

		this.images = [];

		this.numeroTramosCortados = 0;

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		this.cargarEntidades()
		.then(function () {
			// that.listaContenidosCaducar = that.obtenerProximosCaducar(that.listaContenidos);

			const hoy = new Date();
        	const inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1, hoy.getHours(), hoy.getMinutes());
        	const fin = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0, hoy.getHours(), hoy.getMinutes());

			/*that.cargarIndicadoresContenidos({
				inicio: inicio,
				fin: fin
			});*/

			that.cargarIndicadores();
			that.obtenerChartData();
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
		});
	}

	ngAfterViewInit() {
		//(document.querySelector('#dialogMapaMaximizado .ui-dialog-content') as HTMLElement).style.height = '900px';
		this.cd.detectChanges();
	}

	calculaTimeCache(){
		const fec = new Date();
		const timestamp = fec.getTime() - (fec.getTime() % (CACHE_DESF_SEC * 1000));


		return timestamp;
	}

	addResumen(_clave, _valor, _rango = ''){
		let _simbolo = '';
		if (_valor > 1000 ){
			_valor = Math.floor(_valor / 1000);
			_simbolo = 'k';
		}
		if (_valor > 1000 ){
			_valor = Math.floor(_valor / 1000);
			_simbolo = 'm';
		}

		this.listaResumen[_clave] = {
			clave: _clave,
			valor: _valor,
			simbolo: _simbolo,
			rango: _rango
		};

	}

	cubo_Total_MesYear(listaTotal) {
		const colores = ['#FFC107'];
	}

	cubo_Total_Diames(listaTotal) {
		const _coloresT = ['#FFC107', '#a9e53b', '#C107FF' ];
		const colores = {};
		const datos = {};
		let _tits = [];
		for (const _n in listaTotal) {

			const _lista = listaTotal[_n];
			const _tit = _lista.Year + '' + _lista.Mes;
			if (!datos[_tit]) {
				datos[_tit] = [];
				_tits.push(_tit);
			}

			datos[_tit].push(_lista);
		}

		_tits = _tits.sort();
		for (const i in _tits){
			const _serie = _tits[i];
			if (_coloresT[i]){
				colores[_serie] = _coloresT[i];
			}else{
				colores[_serie] = _coloresT[_coloresT.length - 1];
			}
		}

		const _labels = [];
		for (let _i = 1; _i <= 31; _i++){
			if ( _i === 1 || (_i % 5 === 0 && _i !== 30)  || _i === 31){
				_labels.push(_i);
			}else{
				_labels.push('');
			}
		}

		const _datasets = [];

		const totales = {};
		const iniciales = {};


		for (const _serie in datos) {

			if (!totales[_serie]){
				totales[_serie] = 0;
				iniciales[_serie] = 0;
			}

			const valores_filas = [];
			let _ultimo = 0;
			for (const _fila in datos[_serie]) {
				const _dia = datos[_serie][_fila].Dia;

				for (let _k = _ultimo; _k < _dia ; _k++) {
					valores_filas[_k - 1] = (totales[_serie]);
				}
				_ultimo = _dia;

				if (iniciales[_serie] === 0){
					// iniciales[_serie] = datos[_serie][_fila].Total;
				}

				// totales[_serie] += datos[_serie][_fila].Total -  iniciales[_serie];
				totales[_serie] += 1 -  iniciales[_serie];

				valores_filas[_dia - 1] = (totales[_serie]);
			}
			_datasets.push({
				label: this.statsService.MESES[_serie],
				fill: false,
				borderColor: colores[_serie],
				data: valores_filas
			});

		}

		// console.log(_datasets);

		this.chartDataMensual = {
			labels: _labels,
			datasets: _datasets
		};
		let fecha = new Date();
		let dia = fecha.getDate();

		let diasMesAnterior = 999;

		if(fecha.getMonth() !== 0){
			diasMesAnterior = new Date(fecha.getFullYear(), fecha.getMonth(), 0).getDate();
		}else{
			diasMesAnterior = new Date(fecha.getFullYear() - 1, 12, 0).getDate();
		}


		_datasets.forEach(element => {
			if(element.borderColor === '#a9e53b'){
				let valor = element.data[element.data.length - 1]
				while(element.data.length < dia){
					element.data.push(valor)
				}
			}else{
				let valor = element.data[element.data.length - 1]
				while(element.data.length < diasMesAnterior){
					element.data.push(valor)
				}
			}

		});

		console.log(this.chartDataMensual);

		this.chartMensaje = 'Visitas mensuales';
	}

	obtenerChartData() {
		const timeCache = this.calculaTimeCache();
		const token = this.authService.getToken();

		const idEspacio = this.authService.getIdEspacio();

		const ahora = new Date();

		const mesAnterior = new Date();
		mesAnterior.setDate(1);
		mesAnterior.setMonth(mesAnterior.getMonth() - 1);


		const fInicio = this.statsService.fechaToCubefec(mesAnterior);
		const fFin = this.statsService.fechaToCubefec(ahora);
		const rangoF = fInicio.fecha + ',' + fFin.fecha;


		const filtro = {
			Group: 'Mes,Dia,Usuario',
			Order: 'Dia',
			RangeFecha: rangoF,
			Espacio: idEspacio,
			cache: 'CUBEDASH1_B_' + rangoF + idEspacio + timeCache,
			tipo: VISITAUSUARIOS
		};

		const that = this;

		this.statsService.statsVisitaCuenta(token, filtro, function (res) {
			that.listaVisitasDiarias = res.lista;
			that.cubo_Total_Diames(res.lista);
		});


	}

	getDayMonthText(_date: Date){
		const dia = _date.getDate();
		const _numMes = _date.getMonth() + 1;

		const mes = this.translate.instant('Graficas.MesRed' + (_numMes));

		return dia + ' ' + mes;
	}
/*
	cargarIndicadoresContenidos(dateRange){
		console.log(dateRange);
		const _contenidos = this.listaContenidos;
		if (!_contenidos){
			return;
		}

		this.contenidosIndicadores = {};

		this.contenidosIndicadores.total = _contenidos.length;

		const ahora = new Date();
		const idEspacio = this.authService.getIdEspacio();
		const token = this.authService.getToken();
		const that = this;
		const timeCache = this.calculaTimeCache();


		const horaFin = ahora.getHours() * 100 + ahora.getMinutes();
		let horaIni = horaFin;

		const fInicio = this.statsService.fechaToCubefec(dateRange.inicio);
		const fFin = this.statsService.fechaToCubefec(dateRange.fin) ;
		const rangoF = fInicio.fecha + ',' + fFin.fecha;

		let group = 'Contenido_id';
		if (dateRange.lastMinutes != null){
			group += ',Hora';
			horaIni -= dateRange.lastMinutes;

		}

		const filtroContenido = {
			Group: group,
			RangeFecha: rangoF,
			Espacio: idEspacio,
			cache: 'CUBEDASHCONT_D_' + idEspacio + rangoF + timeCache,
			tipo: BUSCACONTENIDO,
			Order: 'Total DESC',
		};

		const todosContenidosById = {};
		_contenidos.forEach(element => {
			todosContenidosById[element.Id] = element;
		});

		// console.log(todosContenidosById);

		this.statsService.statsVisitaCuenta(token, filtroContenido, function (res) {
			if (!res.lista){
				return;
			}
			// console.log(res);
			const total = res.lista.length;
			let max = 7;
			const contenidosFiltrados = [];
			that.todosContenidosFiltrados = [];
			let COUNT = 0;
			for ( const i in res.lista){
				if (! res.lista[i] || ! res.lista[i].Contenido){
					continue;
				}
				const _contenido = todosContenidosById[res.lista[i].Contenido];
				if (!_contenido){
					continue;
				}

				if (dateRange.lastMinutes != null){
					const _hora = parseInt(res.lista[i].Hora, 0);
					if (!(horaIni <= _hora && _hora <= horaFin)){
						continue;
					}
				}
				// console.log(res.lista[i]);

				_contenido.Total = res.lista[i].Total;
				COUNT += _contenido.Total ;

				// console.log(_contenido);

				max--;
				if ( max >= 0){
					contenidosFiltrados.push(_contenido);
				}
				that.todosContenidosFiltrados.push(res.lista[i]);
			}
			// console.log(contenidosFiltrados);

			let _n = 0;
			contenidosFiltrados.forEach(element => {
				element.percent = Math.floor(element.Total * 10000 / COUNT) / 100;
				element.num = _n + 1;
				element.class = '';
				if ( _n === 0){
					element.class = 'lineaPrimera';
				}
				_n++;
			});

			that.contenidosIndicadores.lista = contenidosFiltrados;

		});



	}
	hayContenidos(): boolean{
		if(this.contenidosIndicadores && this.contenidosIndicadores.lista && this.contenidosIndicadores.lista.length === 0){
			return true;
		}
		else {
			return false;
		}
	}
	onChangeRangeContents(dateRange){
		this.cargarIndicadoresContenidos(dateRange);

	}
*/

	onChangeRangeHotMap(dateRange){
		// console.log("----------- EJECUTADO onChangeRangeHotMap");
		// console.log(dateRange);


		const idEspacio = this.authService.getIdEspacio();
		const timeCache = this.calculaTimeCache();
		const token = this.authService.getToken();
		const that = this;

		const ahora = new Date();
		const horaFin = ahora.getHours() * 100 + ahora.getMinutes();
		let horaIni = horaFin;

		const fInicio = this.statsService.fechaToCubefec(dateRange.inicio);
		const fFin = this.statsService.fechaToCubefec(dateRange.fin) ;
		const rangoF = fInicio.fecha + ',' + fFin.fecha;

		//let group = 'Seccion,Usuario,Fecha';
		let group = 'Nodo,Usuario,Fecha';
		if (dateRange.lastMinutes != null){
			group += ',Hora';
			horaIni -= dateRange.lastMinutes;
		}



		const filtro = {
			Group: group,
			RangeFecha: rangoF,
			Espacio: idEspacio,
			Order: 'Nodo',
			cache: 'CUBEDASH1_RV_' + rangoF + idEspacio + timeCache,
			tipo: VISITAUSUARIOS
		};





		this.spinner.style.display = 'inherit';

		this.statsService.statsVisitaCuenta(token, filtro, function (res) {
			that.spinner.style.display = 'none';
			if (dateRange.lastMinutes != null){
				const _finLista = [];
				for (const _i in res.lista){
					const _reg = res.lista[_i];
					const _hora = parseInt(_reg.Hora, 0);
					if (horaIni <= _hora && _hora <= horaFin){
						_finLista.push(_reg);
					}
				}
				res.lista = _finLista;
			}

			const agrupa = function(xs, key) {
				return xs.reduce(function(rv, x) {
				  (rv[x[key]] = rv[x[key]] || []).push(x);
				  return rv;
				}, {});
			  };

			const _nuevaLista = agrupa(res.lista, 'Seccion');

			const _nuevaLista2 = [];
			for (const _i in _nuevaLista){
				const total = _nuevaLista[_i].length;
				if (total === 0){
					continue;
				}

				_nuevaLista[_i][0].Total = total;
				_nuevaLista2.push(_nuevaLista[_i][0]);

			}

			that.visitasSeccion = _nuevaLista2;

			console.log("visitasSeccion: ", that.visitasSeccion);

			//TODO: Añadido 27/02/2020: Vamos a hacer una consulta por Nodos:
			const _nuevaListaNodos = agrupa(res.lista, 'Nodo');

			const _nuevaLista2Nodos = [];
			for (const _i in _nuevaListaNodos){
				const total = _nuevaListaNodos[_i].length;
				if (total === 0){
					continue;
				}

				_nuevaListaNodos[_i][0].Total = total;
				_nuevaLista2Nodos.push(_nuevaListaNodos[_i][0]);

			}

			that.visitasNodo = _nuevaLista2Nodos;

		});

	}




	// Cargar visitas de hoy, semana y mes
	cargarIndicadores() {
		const timeCache = this.calculaTimeCache();
		const token = this.authService.getToken();
		const that = this;

		const idEspacio = that.authService.getIdEspacio();

		const ahora = new Date();

		this.hotMapMes = 'Mes' + (ahora.getMonth() + 1 );

		let area = this.authService.getAreaEspacio();
		console.log(area)
		if(area !== "undefined"){

			that.listaResumen["Area_espacio"] = {
				clave: "Area_espacio",
				valor: area,
				simbolo: "m",
				rango: ""
			};
		}


		const filtro = {
			Group: 'Mes,Dia,Usuario',
			Year: ahora.getFullYear(),
			Mes: ahora.getMonth() + 1 ,
			Espacio: idEspacio,
			cache: 'CUBEDASH2' + idEspacio + timeCache,
			tipo: VISITAUSUARIOS
		};

		const rango1 = this.translate.instant('Graficas.Mes' + filtro.Mes) ;

		this.statsService.statsVisitaCuenta(token, filtro, function (res) {
			const total = res.lista.length;
			/*
			if (res.lista && res.lista.length > 0){
				total = res.lista[0].Total;
			}
			*/
			that.addResumen('Visitas_este_mes', total, rango1);
		});

		const filtro2 = {
			Group: 'Year,Usuario',
			RangeFecha: this.statsService.getWeekRange(new Date(), false),
			Espacio: idEspacio,
			cache: 'CUBEDASH3' + idEspacio + timeCache,
			tipo: VISITAUSUARIOS
		};

		const rang: any = this.statsService.getWeekRange(new Date(), true);

		const rango2 = this.getDayMonthText(rang.monday) + ' - ' + this.getDayMonthText(rang.sunday);


		this.statsService.statsVisitaCuenta(token, filtro2, function (res) {
			const total = res.lista.length;
			/*
			if (res.lista && res.lista.length > 0){
				total = res.lista[0].Total;
			}
			*/
			that.addResumen('Visitas_esta_semana', total, rango2);
		});

		const filtro3 = {
			Group: 'Dia,Usuario',
			Year: ahora.getFullYear(),
			Mes: ahora.getMonth() + 1,
			Dia: ahora.getDate(),
			Espacio: idEspacio,
			cache: 'CUBEDASH4' + idEspacio + timeCache,
			tipo: VISITAUSUARIOS
		};

		const rango3 = this.getDayMonthText(ahora);

		this.statsService.statsVisitaCuenta(token, filtro3, function (res) {
			const total = res.lista.length;
			that.addResumen( 'Visitas_hoy', total, rango3);
		});



		const hoy = new Date();
        const inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1, hoy.getHours(), hoy.getMinutes());
        const fin = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0, hoy.getHours(), hoy.getMinutes());

		this.onChangeRangeHotMap({
			inicio: inicio,
			fin: fin
		});


		const filtro5 = {
			Group: 'Mes,Dia,Usuario',
			RangeFecha: this.statsService.getLastMonthsRange(6),
			Espacio: idEspacio,
			Order: 'fecha DESC',
			cache: 'CUBEDASH6_E_' + idEspacio + timeCache,
			tipo: VISITAUSUARIOS
		};

		this.statsService.statsVisitaCuenta(token, filtro5, function (res) {


            const mesesReales = [];
            const fecha = new Date();
            const mesActual = fecha.getMonth() + 1;
            let obj = {Mes: mesActual, Total: 0}
            mesesReales.push(obj)
            let actual = mesActual;
            for (let index = 1; index < 6; index++) {

                let mes = actual - 1;
                if(mes === 0){
                    mes = 12;
                }
                let obj = {Mes: mes, Total: 0}
                mesesReales.push(obj)
                if(mes === 12){
                    actual = 12;
                }else{
                    actual--;
                }


            }
            if(res.lista.length > 0){
                res.lista.forEach(element => {
                    let mesElement = mesesReales.find(m => m.Mes === +element.Mes);
					if (!mesElement) {
						console.log("No mesElement para: ", element)
					}
					else {
						mesElement.Mes = +element.Mes
						mesElement.Total++;
					}
                });
            }

            that.chartDataMensualLast = mesesReales;

        });

		

			/*
			if (!res.lista){
				that.chartDataMensualLast = [];
				return;
			}

			const prelista = {};
			const prelista2 = {};

			res.lista.forEach(element => {
				if (!prelista[element.Fecha]){
					prelista[element.Fecha] = element;
					prelista[element.Fecha].Total = 0;
				}
				prelista[element.Fecha].Total++;
			});



			for (const i in prelista){
				const _lista2 = prelista[i];
				if (!prelista2[_lista2.Mes]){
					prelista2[_lista2.Mes] = _lista2;
					prelista2[_lista2.Mes].Total = _lista2.Total;
				}else{
					prelista2[_lista2.Mes].Total += _lista2.Total;
				}
			}



			const _l2: any = Object.values(prelista2);

			console.log(_l2)

			const listado = _l2.sort(function(a, b){
				if (a.Fecha > b.Fecha){
					return -1;
				}

				if (a.Fecha < b.Fecha){
					return 1;
				}

				return 0;

			});



			that.chartDataMensualLast = listado;


		});
		*/
	}

	contenidoSeleccionado(contenido) {

	}

	descargaAcumulados(event){
		console.log(this.listaVisitasDiarias);

		const datos = [];
		this.listaVisitasDiarias.forEach(elem => {

			datos.push({
				Fecha: elem.Dia + '/' + elem.Mes + '/' + elem.Year ,
				Total: elem.Total
			});
		});

		const csv = new Angular5Csv(datos, 'Visitas_diarias', {
			headers: ['Fecha', 'Total' ],
			fieldSeparator: "#"
		});
	}

	descargaHotMap(event){

		const Suma = this.visitasSeccion.reduce((a, b) => ({Total: a.Total + b.Total}));
		const datos = [];
		this.visitasSeccion.forEach(elem => {
			datos.push({
				Nombre: this.secciones[elem.Seccion] ? this.secciones[elem.Seccion].nombre : '',
				Total: elem.Total,
				Percentage: Math.floor(10000 * elem.Total / Suma.Total) / 100
			});
		});

		const csv = new Angular5Csv(datos, 'Zonas_mas_visitadas', {
			headers: ['Zona', 'Total', 'Porcentaje'],
			fieldSeparator: "#"
		});

	}

	maximizarHotMap(event) {
		//this.mapaPantallaCompletaVisible = true;
		// console.log("----------- VALOR DE event en maximizarHotMap");
		this.numAla = event.numAla;
    	this.numTipo = event.numTipo;

		// console.log(event);

		//FIXME: Modificado: 06/04/2020:
		if (this.mapaPantallaCompletaVisible) {
			this.mapaPantallaCompletaVisible = false;
		} else {
			this.mapaPantallaCompletaVisible = true;
		}
	}

	cerrarHotMapMaximizado() {
		this.mapaPantallaCompletaVisible = false;
	}

	descargaContenidos(event){
		const _contenidos = {};
		this.listaContenidos.forEach(elem => {
			_contenidos[elem.Id] = {
				Nombre: elem.Titulo
			};
		});

		const Suma = this.todosContenidosFiltrados.reduce((a, b) => ({Total: a.Total + b.Total}));
		const datos = [];
		this.todosContenidosFiltrados.forEach(elem => {
			datos.push({
				Nombre: _contenidos[elem.Contenido] ? _contenidos[elem.Contenido].Nombre : '',
				/*
				Dia: elem.Dia,
				Hora: elem.HoraFull,
				Mes: elem.Mes,
				Year: elem.Year,
				*/
				Seccion: this.secciones[elem.Seccion] ? this.secciones[elem.Seccion].nombre : '',
				Total: elem.Total,
				Percentage: Math.floor(10000 * elem.Total / Suma.Total) / 100
			});
		});

		const csv = new Angular5Csv(datos, 'Contenidos', {
			headers: ['Nombre', 'Seccion', 'Total', 'Percentage'],
			fieldSeparator: "#"
		});

	}

	obtenerProximosCaducar(contenidos) {
		const caducar = contenidos.filter(x => this.dayDiff(x.FechaBaja, new Date()) < Constantes.DIAS_PROXIMOS_EXPIRAR);
		return caducar;
	}

	dayDiff(firstDate: Date, secondDate: Date) {
		const date2 = secondDate;
		const date1 = firstDate;
		if (date2 !== undefined && date2 !== null && date1 !== undefined && date1 !== null) {
			const timeDiff = Math.abs(date2.getTime() - date1.getTime());
			const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
			return diffDays;
		}
		else {
			return 999;
		}
	}

	onShowHotMap(){
		//(document.querySelector('#dialogMapaMaximizado .ui-dialog-content') as HTMLElement).style.height = '900px';

		/* var el = document.querySelector('#dialogMapaMaximizado .ui-dialog-content');
		this.css(el, { height: '900px', offsetHeight: '900px', cssText:'height: 900px;' });
		var el2 = document.querySelector('#dialogMapaMaximizado .ui-dialog-content'); */
	}
	css(el, styles) {
		for (var property in styles)
			el.style[property] = styles[property];
	}

	onCloseHotMap(){

	}

	cargarEntidades(): Promise<any> {
		const that = this;

		return this.obtenerCONTENIDO()
			.then(function (flag) {
				return that.obtenerRUTA_SUGERIDA();
			})
			.then(function (flag) {
				return that.obtenerTramosCortados();
			})
			.then(function (flag) {
				return that.obtenerValoresBalizas();
			})
			.then(function (flag) {
				return flag;
			})
			.catch(function (e) {
				this.appComponent.showError(e.message);
				const codigo = e.status;
				return false;
			});

	}

	obtenerCONTENIDO(): Promise<any> {
		const that = this;
		const entityManager = that.entityManager;
		const token = that.authService.getToken();

		const idEspacio = that.authService.getIdEspacio();
		const predicado = undefined;
		const includes = undefined;
		return entityManager.getCONTENIDO(predicado, includes)
			.then(function (contenidos) {
				that.listaContenidos = contenidos;
				return that.sws.ObtenerFavoritos(token ,idEspacio).toPromise()
			})
			.then(favoritos =>{
				that.listaContenidosFavoritos = favoritos;
			})
			.catch(function (e) {
				that.appComponent.showError(e.message);
				return false;
			});

	}

	obtenerRUTA_SUGERIDA(): Promise<any> {
		const that = this;
		const entityManager = that.entityManager;

		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate('idEspacio', '==', idEspacio);
		const includes = 'FOTOS';

		return entityManager.getRUTA(predicado, includes)
			.then(function (rutas) {
				that.listaRutas = rutas;


				rutas.forEach(element => {
					let oFoto;
					const token = that.authService.getToken();
					let image;

					if (element.FOTOS.length > 0) {
						const ultima = element.FOTOS.length - 1;
						if (ultima >= 0) {
							oFoto = element.FOTOS[ultima];
							if (oFoto.UrlFotoExt) {
								image = oFoto.UrlFotoExt;
							}
							else{
								image =  environment.urlBaseFotos +  oFoto.IdFotoExt;
							}
						}
						else {
							image = that.authService.getFotoPorDefecto();
						}

						that.listaFotosRutasURL.push({
							id: oFoto.Id,

						});
					}

				});

				that.addResumen( 'numRutas', rutas.length);

			})
			.catch(function (e) {
				that.appComponent.showError(e.message);
				return false;
			});
	}

	onLoadSecciones(secciones){
		// console.log("------------------- EJECUTANDO onLoadSecciones");
		this.secciones = secciones;
	}


	obtenerTramosCortados() {
		const that = this;
		const entityManager = that.entityManager;

		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		const includes = undefined;
		const token = this.authService.getToken();
		// const includes = 'NodoOrigen.SECCION.ALA.NIVEL';
		// return entityManager.getTramosCortados(predicado, includes)
		return this.sws.wsGetTramosCortados(token, idEspacio).toPromise()
		.then(function (tramos) {
			that.numeroTramosCortados = tramos.length / 2;

			that.addResumen( 'tramoscortados', tramos.length / 2);
			//that.addResumen( 'metrosCuadrados', tramos.length / 2);

			
			return tramos;
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	obtenerValoresBalizas() {
		const that = this;
		this.spinner.style.display = 'inherit';
		this.entityManager.getBalizasEspacio()
		.then(function(BALIZAs){
			that.addResumen( 'numBeacons', BALIZAs.length );

			const _balizasBateria = [];
			const _balizasPerdidas = [];
			const ahora = new Date();
			let pocaBateria = 0;
			let tiempoSinVer = 0;
			BALIZAs.forEach(element => {
			 	const baliza = new BalizaFormulario_lite().fromENTIDAD(element);
				let fecha;
				if (baliza.TimestampLecturaBateria) {
					const year = parseInt(baliza.TimestampLecturaBateria.substr(0, 4), 0);
					const month = parseInt(baliza.TimestampLecturaBateria.substr(4, 2), 0);
					const day = parseInt(baliza.TimestampLecturaBateria.substr(6, 2), 0);
					fecha = new Date();
					fecha.setFullYear(year);
					fecha.setMonth(month - 1);
					fecha.setDate(day + BEACONMINDAYS);
				}

				if (baliza.NivelBateria < BEACONBATERIAMIN){
					pocaBateria++;
					_balizasBateria.push(baliza);
				}

				if (fecha === undefined || fecha < ahora ){
					tiempoSinVer ++;
					_balizasPerdidas.push(baliza);
				}

			 });

			that.addResumen( 'beaconPocaBateria', pocaBateria);
			that.addResumen( 'beaconTiempoSinVer', tiempoSinVer);
			return true;
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	/* Navegar a: */


	navegarRutaSugerida(){
		this.router.navigate(['/rutas-sugeridas']);
	}

	navegarPlanos(){
		this.router.navigate(['/mapas']);
	}

	navegarBeacons(order){
		this.router.navigate(['/balizas'], { queryParams: { order: order }});
	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({ severity: 'error', detail: mensaje });
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({ severity: 'success', detail: mensaje });
	}

	randonValue(){
		var val = Math.floor(Math.random() * 100);
		return val;
	  }

	generarPuntosEjemplo(){
		// now generate some random data
		var points = [];

		// Entrada
		var val = this.randonValue();
		var point = {
		  x: 1768,
		  y: 1758,
		  value: val
		};
		points.push(point);

		// Tienda
		val = this.randonValue();
		point = {
		  x: 1651,
		  y: 1718,
		  value: val
		};
		points.push(point);

		// Punto Informacion
		val = this.randonValue();
		point = {
		  x: 1935,
		  y: 1796,
		  value: val
		};
		points.push(point);


		// Claustro 1-1
		val = this.randonValue();
		point = {
		  x: 1799,
		  y: 1580,
		  value: val
		};
		points.push(point);

		// Claustro 1-1-4
		val = this.randonValue();
		point = {
		  x: 1799,
		  y: 1404,
		  value: val
		};
		points.push(point);

		// Claustro 1-4
		val = this.randonValue();
		point = {
		  x: 1828,
		  y: 1161,
		  value: val
		};
		points.push(point);

		return points;
	  }

}




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Dashboard/dashboard.component.ts